import { Firehose } from 'aws-sdk';
import React from 'react';
import { FontAwesomeConfigurations } from '../../utils/Configuration/FontAwesomeConfiguration';

interface SocialIconsComponentProps {
  content: object;
  openExternalUrl: Function;
  trackExternalClick: Function;
}

const SocialIcons: React.FC<SocialIconsComponentProps> = ({ content, openExternalUrl, trackExternalClick }) => {
  const links = React.useMemo(() => {
    return {
      //@ts-ignore
      instagram: content.MetaDataSingleValueForKey(
        //@ts-ignore
        CrowdHub_App.META_INSTAGRAM,
      ),
      //@ts-ignore
      facebook: content.MetaDataSingleValueForKey(
        //@ts-ignore
        CrowdHub_App.META_FACEBOOK,
      ),
      //@ts-ignore
      twitter: content.MetaDataSingleValueForKey(
        //@ts-ignore
        CrowdHub_App.META_TWITTER,
      ),
      //@ts-ignore
      linkedin: content.MetaDataSingleValueForKey(
        //@ts-ignore
        CrowdHub_App.META_LINKEDIN,
      ),
      //@ts-ignore
      email: content.MetaDataSingleValueForKey(CrowdHub_App.META_EMAIL),
      //@ts-ignore
      website: content.MetaDataSingleValueForKey(
        //@ts-ignore
        CrowdHub_App.META_WEBSITE,
      ),
    };
  }, [content]);

  let iconsArray = [];

  if (links.email != null) {
    iconsArray.push({
      iconSrc: FontAwesomeConfigurations.ICON_ENVELOPE,
      iconAddress: `mailto: ${links.email}`,
    });
  }

  if (links.facebook) {
    iconsArray.push({
      iconSrc: FontAwesomeConfigurations.ICON_FACEBOOK_F,
      iconAddress: links.facebook,
    });
  }

  if (links.instagram) {
    iconsArray.push({
      iconSrc: FontAwesomeConfigurations.ICON_INSTAGRAM,
      iconAddress: links.instagram,
    });
  }

  if (links.linkedin) {
    iconsArray.push({
      iconSrc: FontAwesomeConfigurations.ICON_LINKEDIN,
      iconAddress: links.linkedin,
    });
  }

  if (links.twitter) {
    iconsArray.push({
      iconSrc: FontAwesomeConfigurations.ICON_TWITTER,
      iconAddress: links.twitter,
    });
  }

  const getIcons = () => {
    return iconsArray.map((icon, index) => {
      return (
        <svg
          onClick={e => {
            trackExternalClick(content.Id, icon.iconAddress);
            openExternalUrl(icon.iconAddress);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              trackExternalClick(content.Id, icon.iconAddress);
              openExternalUrl(icon.iconAddress);
            }
          }}
          tabIndex={0}
          aria-label={`${icon.iconSrc} icon`}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          className="juno_social_icons"
          key={`social_icon_${index}`}
        >
          <i className={`${icon.iconSrc}`}></i>
        </svg>
      );
    });
  };

  return <div className="juno_social_container">{getIcons()}</div>;
};

export default SocialIcons;
